import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_To_find_out_moreX_visit_our_Xa_ELL,
  TXTWCL_We_use_electronic_identity_ver_ELL
} from './HelpSectionVerification.messages.json';

const HelpSectionVerification: React.FC = () => (
  <>
    <Translation {...TXTWCL_We_use_electronic_identity_ver_ELL} />{' '}
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.CustomerVerificationProcess}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_To_find_out_moreX_visit_our_Xa_ELL}
    />
  </>
);

export default HelpSectionVerification;
